import {
  Component,
  OnInit
} from '@angular/core';

import {
  ListState,
  ListStateDispatcher,
  ListItemsLoadAction,
  ListItemModel
} from '../../core';


export class SkyListPagingDemoComponent implements OnInit {
  constructor(
    private dispatcher: ListStateDispatcher
  ) { }

  public ngOnInit() {
    this.dispatcher.next(new ListItemsLoadAction([
      new ListItemModel('1'),
      new ListItemModel('2'),
      new ListItemModel('3'),
      new ListItemModel('4'),
      new ListItemModel('5'),
      new ListItemModel('6'),
      new ListItemModel('7')
    ], true));
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-paging-demo',
  template: `<sky-list-paging
  pageSize="2"
  maxPages="3"
  pageNumber="1">
</sky-list-paging>
`,
  providers: [
    ListState,
    ListStateDispatcher
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ListStateDispatcher, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
